import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ContainerYardForm } from '@/components/forms/ContainerYardForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function ContainerYardEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const [containerYardId, setContainerYardId] = useState<number | null>(null)
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!id) {
      navigate('/container-yards/yard-list', { replace: true })
      return
    }

    const parsedId = Number(id)
    if (Number.isNaN(parsedId)) {
      navigate('/container-yards/yard-list', { replace: true })
      return
    }

    setContainerYardId(parsedId)
    setIsValidating(false)
  }, [id, navigate])

  const handleSuccess = () => {
    navigate('/container-yards/yard-list')
  }

  const handleCancel = () => {
    navigate('/container-yards/yard-list')
  }

  if (isValidating || containerYardId === null) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Container Yard</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update container yard details
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <ContainerYardForm containerYardId={containerYardId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
